import { useTranslation } from '@shared/localization';
import { useSearchParams } from 'react-router-dom';

import { PageLayout } from '@/components/common';
import {
  AlertError,
  AlertSuccess,
  AlertWarning,
} from '@/components/common/alerts';

export function PaymentResultGeneric() {
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const status = searchParams.get('status') ?? '';

  return (
    <PageLayout>
      {status === 'successful' && (
        <AlertSuccess
          title={t('Payment successful!')}
          description={undefined}
        ></AlertSuccess>
      )}
      {status === 'failed' && (
        <AlertError
          title={t(
            'Operation failed. Please try again with a different payment method.',
          )}
          description={undefined}
        ></AlertError>
      )}
      {status === 'canceled' && (
        <AlertWarning
          title={t('Payment was canceled!')}
          description={undefined}
        ></AlertWarning>
      )}
    </PageLayout>
  );
}
